import React from 'react'
import PropTypes from 'prop-types'
import { useField } from '@unform/core'
import { Container, Error } from './styles'
import { FiAlertOctagon } from 'react-icons/fi'

const Radio = ({ label, name, horizontal, options, onChange }) => {
  const inputRefs = React.useRef([])
  const { fieldName, registerField, defaultValue, error } = useField(name)

  React.useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRefs.current,
      getValue (refs) {
        const checked = refs.find((ref) => ref.checked)
        return checked?.value || null
      },
      setValue (refs, value) {
        const item = refs.find((ref) => ref.value === value)

        if (item) {
          item.checked = true
        }
      }
    })
  }, [fieldName, registerField])

  return (
    <Container horizontal={horizontal} onChange={onChange}>
      {label && <div className="radio__name">{label}</div>}

      {options.map((option, index) => (
        <label className="radio__item" key={option.id}>
          <input
            className="radio__input"
            ref={(elRef) => (inputRefs.current[index] = elRef)}
            type="radio"
            name={fieldName}
            value={option.id}
            defaultChecked={String(defaultValue) === String(option.id)}
          />
          <span className="radio__label">{option.label}</span>
        </label>
      ))}

      {error && (
        <Error title={error}>
          <FiAlertOctagon color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  )
}

Radio.defaultProps = {
  horizontal: false,
  onChange: () => {}
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  horizontal: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      label: PropTypes.string
    })
  ).isRequired
}

export default Radio
